var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsTradeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 10.7916V6.83325M16.1667 6.83325H12.2083M16.1667 6.83325L12.2083 10.7916C11.5093 11.4906 11.1602 11.8398 10.7319 11.8785C10.6606 11.8849 10.5894 11.8849 10.5181 11.8785C10.0898 11.839 9.74071 11.4906 9.04167 10.7916C8.34263 10.0925 7.9935 9.74342 7.56521 9.70463C7.4941 9.6982 7.42256 9.6982 7.35146 9.70463C6.92317 9.74421 6.57404 10.0925 5.875 10.7916L3.5 13.1666",
    stroke: "#04D538",
    strokeWidth: 1.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsTradeUp);
export default __webpack_public_path__ + "static/media/hugeicons_trade-up.fc1fd65b1e6b1559e818044c6b146c0d.svg";
export { ForwardRef as ReactComponent };